<div class="fixed-bottom flex flex-col space-y-2">
    <img
        alt="Cevo logo"
        [class]="isCollapsed ? 'mb-5 mx-1' : 'w-20 mx-auto'"
        src="assets/svg/cevo_icon.svg"
    />
    @if (!isCollapsed) {
        <div class="flex flex-col px-3 pb-2 space-y-2">
            <button
                [routerLink]="profileRoute"
                mat-raised-button
                primary
                thin
                routerLink="/profile"
            >
                My Profile
            </button>
            <app-sidenav-bottom-panel-info></app-sidenav-bottom-panel-info>
        </div>
    }
</div>
